import { render, staticRenderFns } from "./files.vue?vue&type=template&id=5342575e&"
import script from "./files.vue?vue&type=script&lang=ts&"
export * from "./files.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports